import { createContext, useContext } from "react";

/** El torneo de la página sigue en borrador (lo sabe `TournamentSetupGuard`,
 * que ya cargó el torneo). Las piezas de operación — la barra de abajo, el
 * «Volver» del detalle del jugador — lo leen para no sacar al admin del
 * asistente (revisión del borrador, Eduardo 2026-10-02). Fuera del guard vale
 * `false`: se comporta como siempre. */
export const DraftTournamentContext = createContext(false);

export function useIsDraftTournament(): boolean {
  return useContext(DraftTournamentContext);
}
